import { useCallback, useEffect, useRef, useState } from 'react';
import { AppModal } from '@/components/compose/app.modal';
import styled from 'styled-components/native';
import { actionSetUser } from '@/redux';
import { AppPressable } from '@/components/base/app.pressable';
import { AppTextField } from '@/components/base/app.text.field';
import { Box } from '@/components/base/box';
import { AppAvatar } from '@/components/compose/app.avatar';
import { useFilePicker } from '@/hooks/use.file.picker';
import { useAppDispatch } from '@/hooks/use.redux';
import { useUser } from '@/hooks/use.user';
import { Endpoints, GenderEnum } from '@matap/shared';
import { AppDropdownMenu } from '@/components/compose/app.dropdown.menu';
import { usePatchProfile } from '@/apis/user';
import { useNavigation } from '@react-navigation/native';
import { hpVal, minVal } from '../../utils';

export default function ProfileSettingsModal() {
  const navigation = useNavigation();
  const { user } = useUser();
  const [name, setName] = useState(user.name);
  const dispatch = useAppDispatch();
  const [gender, setGender] = useState(user.gender);
  const { mutate } = usePatchProfile({
    onSuccess: (data) => dispatch(actionSetUser(data)),
  });

  const initialValues = useRef({ gender: user.gender, name: user.name });
  const filePicker = useFilePicker();

  useEffect(() => {
    const unsubscribe = navigation.addListener('beforeRemove', (e) => {
      if (name !== initialValues.current.name || gender !== initialValues.current.gender) {
        mutate({ body: { name, gender } });
      }
    });
    return () => unsubscribe();
  }, [navigation, name, gender, mutate]);

  const onImagePress = useCallback(() => {
    filePicker.pickGallery().then((file) => {
      if (file) {
        file.upload(Endpoints.users.user.profileImage.path).then((fileRecord) => {
          dispatch(
            actionSetUser({
              ...user,
              imageFile: fileRecord,
            }),
          );
        });
      }
    });
  }, [dispatch, filePicker, user]);

  return (
    <AppModal title={'تنظیمات پروفایل'}>
      <Container>
        <AppPressable onPress={onImagePress}>
          <Avatar url={user.imageFile?.metadata.url} />
        </AppPressable>
        <RowContainer>
          <AppTextField fullWidth placeholder={'نام و نام خانوادگی'} value={name} onChangeText={setName} border={false} />
        </RowContainer>
        <RowContainer>
          <AppDropdownMenu
            label={'جنسیت:'}
            items={[
              { key: GenderEnum.UNKNOWN, label: 'نامشخص' },
              { key: GenderEnum.MALE, label: 'آقا' },
              { key: GenderEnum.FEMALE, label: 'خانم' },
            ]}
            selectedKey={user.gender || GenderEnum.UNKNOWN}
            onSelect={(key: GenderEnum) => setGender(key)}
          />
        </RowContainer>
      </Container>
    </AppModal>
  );
}

const RowContainer = styled(AppPressable)`
  width: 100%;
  padding-vertical: ${hpVal(2)};
  border-color: ${({ theme }) => theme.colors.greyWhite};
  flex-direction: row-reverse;
  align-items: center;
`;

const Avatar = styled(AppAvatar)`
  width: ${minVal(30)};
  height: ${minVal(30)};
  max-width: 150px;
  max-height: 150px;
  margin-bottom: 50px;
`;

const Container = styled(Box)`
  margin-top: 50px;
  align-items: center;
  padding-horizontal: 5%;
`;
